/**
 * Created by mohameds on 8/7/19.
 */
import {LOG_OUT,
  MONITOR_HEADER_SETTINGS,
  ALL_USERS,
  ALL_PAGES,
  ALL_PAGE_POSITION,
  ALL_KPIS,
  ADD_TO_PAGE_POSITION,
  DELETE_PAGE_POSITION,
  GET_PAGE_DATA,
  SAVE_STATE,
  REMOVE_STATE,
  AGENCY_PL_PROFILE
} from "./ActionTypes";
import AgencyMonitorService from "../services/AgencyMonitorService";
import KPIService from "../services/KPIService";
import {MonitorConst} from '../components/agencyMonitor/Constants';
import {getUser} from "../utils/TokenManager";
import {isEmpty} from 'lodash'


const headerSettings = (headerData) => ({
  type: MONITOR_HEADER_SETTINGS,
  headerData
});
const allUsers = (userData) => ({
  type: ALL_USERS,
  userData
});
const allPages = (pageData) => ({
  type: ALL_PAGES,
  pageData
});
const pagePosition = (pagePosition) => ({
  type: ALL_PAGE_POSITION,
  pagePosition
});

const allKpis = (kpis) =>({
  type: ALL_KPIS,
  kpis
});

const addToPagePosition = (data) =>({
  type: ADD_TO_PAGE_POSITION,
  data
});
//delete page position =
const deletePagePosition = (pageId) =>({
  type: DELETE_PAGE_POSITION,
  pageId
});

const getPageData = (pageData, prevData = {}) =>({
  type: GET_PAGE_DATA,
  pageData,
  prevData
});
//get agency profile
const setAgencyProfile = (profileList) =>({
  type: AGENCY_PL_PROFILE,
  profileList
});

export const saveState = (state) => ({type : SAVE_STATE, state : state});
export const removeState = () => ({ type : REMOVE_STATE });

const logOutSuccess = () => ({type: LOG_OUT});

export const getHeaderSettings = (locationId) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getHeaderSettings(locationId);

      if (200 === result.status) {
        dispatch(headerSettings(result.data));
        return true;
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      console.log(error.response);
      throw error.response;
    }
    return false;
  }
);

export const saveHeaderSettings = (locationId, headerData) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.postHeaderSettings(locationId, headerData);

      if (getUser()['app-version'] !== result.headers['app-version']) {
          dispatch(logOutSuccess());
      }

      if (200 === result.status) {
        dispatch(headerSettings(result.data));
        return true;
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);

export const getAllUsers = (locationId) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getUsers(locationId);

      if (getUser()['app-version'] !== result.headers['app-version']) {
          dispatch(logOutSuccess());
      }

      if (200 === result.status) {
        dispatch(allUsers(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);
export const getPageList = () => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getPageList();

      if (200 === result.status) {
        dispatch(allPages(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);
export const pagePositionList = (userId, action, position = []) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.pagePositionList(userId, action, position,);
      
      if (200 === result.status) {
        if(position.length > 0){
          dispatch(pagePosition(position));
        } else{
          dispatch(pagePosition(result.data));
        }
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);
export const getPageInfo = (pageId) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getPageInformation(pageId);
      if (getUser()['app-version'] !== result.headers['app-version']) {
          dispatch(logOutSuccess());
      }
      if (200 === result.status) {
        //dispatch(pagePosition(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);
export const getAllKPIs = (locationId) => (
  async(dispatch) => {
    try {
      let result = await KPIService.getKPIFilteredBYDate(locationId);

      if (200 === result.status) {
        dispatch(allKpis(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);
export const savePageSettings = (data) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.savePageSetting(data);
      if (getUser()['app-version'] !== result.headers['app-version']) {
          dispatch(logOutSuccess());
      }

      if (201 === result.status) {
        dispatch(addToPagePosition(result.data));
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);

export const resetPageData = () => (
  async(dispatch) => {
    try {
      dispatch(getPageData({
        title: '',
        page_kpis: [],
        goal: true,
        image: '',
        occasion_text: '',
        banner: ''
      }));
    } catch (error) {
      throw error;
    }
    return false;
  }
);

//get/edit/delete page
export const alterPage = (pageId, action, pageData = {}, nextData) =>(
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.alterPageSettings(pageId, action, pageData);
      if (200 === result.status) {
        if(action === MonitorConst.Action.GET) {
          dispatch(getPageData(result.data))
        } else if(action === MonitorConst.Action.DELETE){
          dispatch(deletePagePosition(pageId));
        } else {
          if(!isEmpty(nextData)){
            // when prev page unsaved data is being saved
            // i.e, if a user changes something and the clicked on other page
            dispatch(getPageData(nextData, pageData))
          } else{
            dispatch(getPageData(result.data))
          }

        }
        return true
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);

export const getAgencyProfile = (locationId) => (
  async (dispatch) => {
      try {
        const agencyProfile = await AgencyMonitorService.getAgencyProfileList(locationId);

        if (getUser()['app-version'] !== agencyProfile.headers['app-version']) {
            dispatch(logOutSuccess());
        }
        if (200 === agencyProfile.status) {
          dispatch(setAgencyProfile(agencyProfile.data.pl_profile));
          return true;
        }
      } catch (error) {
          if(401 === error.response.status) {
              dispatch(logOutSuccess());
              return false;
          }
          throw error.response;
      }
      return false;
  }
);

export const getMonitorUserSettings = (userId) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.getMonitorUserSettings(userId);

      if (200 === result.status) {
        return result.data;
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);

export const updateAgecnyMonitorSettings = (userId, settingData) => (
  async(dispatch) => {``
    try {
      let result = await AgencyMonitorService.updateAgecnyMonitorSettings(userId,settingData);

      if (200 === result.status) {
        return result.data;
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);



export const overrideSettings = (userId, headerData) => (
  async(dispatch) => {
    try {
      let result = await AgencyMonitorService.overrideSettings(userId, headerData);

      if (getUser()['app-version'] !== result.headers['app-version']) {
          dispatch(logOutSuccess());
      }

      if (200 === result.status) {
        return result.data;
      }
    } catch (error) {
      if (401 === error.response.status) {
        dispatch(logOutSuccess());
        return false;
      }
      throw error.response;
    }
    return false;
  }
);



// WEBPACK FOOTER //
// ./src/actions/AgencyMonitorAdminAction.js